module.exports = __webpack_public_path__ + "img/MTABAPPWL.3eb39fa2.jpg";